import { AnyAction } from 'redux';
import { PRODUCT_PAGE_SET_SELECTED_VARIANT } from '../constants';
import Product from '../Types/Product';

export interface ProductPageState {
  variants?: Product[];
  selectedVariant?: Product;
}

const DEFAULT_STATE: ProductPageState = {
  selectedVariant: undefined,
  variants: [],
};

export const productPage = (
  state = DEFAULT_STATE,
  action: AnyAction
): ProductPageState => {
  switch (action.type) {
    case PRODUCT_PAGE_SET_SELECTED_VARIANT:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
